import { render, staticRenderFns } from "./StoreBind.vue?vue&type=template&id=80590b04&scoped=true&"
import script from "./StoreBind.vue?vue&type=script&lang=js&"
export * from "./StoreBind.vue?vue&type=script&lang=js&"
import style0 from "styles/views/orderAdmin/storeBind.css?vue&type=style&index=0&id=80590b04&scoped=true&lang=css&"
import style1 from "./StoreBind.vue?vue&type=style&index=1&id=80590b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80590b04",
  null
  
)

export default component.exports